import { RootState } from '@reducers';

export const selectPersonalAccidentQuotePaymentPage = (state: RootState) =>
  state.personalAccidentQuotePaymentPageReducer;
